module.exports = __webpack_public_path__ + "img/child-song2.4a3b9d35.png";